"use client";

import { c as _c } from "react/compiler-runtime";
import { useId, useRef } from "react";

/** Receives positions and user answers only; expected words cannot enter this DOM. */
export function RecoveryPhraseConfirm(t0) {
  const $ = _c(32);
  const {
    positions,
    answers,
    invalid,
    pending,
    onAnswer,
    onCheck,
    onBack
  } = t0;
  const firstInput = useRef(null);
  const errorId = useId();
  let t1;
  if ($[0] !== onCheck || $[1] !== pending) {
    t1 = event => {
      event.preventDefault();
      if (!(pending || onCheck())) {
        firstInput.current?.focus();
      }
    };
    $[0] = onCheck;
    $[1] = pending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm">Enter these three words from your saved copy.</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== answers || $[5] !== errorId || $[6] !== invalid || $[7] !== onAnswer || $[8] !== pending || $[9] !== positions) {
    t3 = positions.map((position, index) => <label className="block space-y-1 text-sm" key={position}><span>Word {position + 1}</span><input aria-describedby={invalid ? errorId : undefined} aria-invalid={invalid} autoCapitalize="none" autoComplete="off" autoCorrect="off" className="min-h-11 w-full rounded-md border bg-background px-3 font-mono" disabled={pending} onChange={event_0 => onAnswer(position, event_0.target.value)} ref={index === 0 ? firstInput : undefined} spellCheck={false} value={answers[position] ?? ""} /></label>);
    $[4] = answers;
    $[5] = errorId;
    $[6] = invalid;
    $[7] = onAnswer;
    $[8] = pending;
    $[9] = positions;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== errorId || $[12] !== invalid) {
    t4 = invalid && <p className="text-destructive text-sm" id={errorId} role="alert">The words do not match. Check your saved copy and try again.</p>;
    $[11] = errorId;
    $[12] = invalid;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== answers || $[15] !== pending || $[16] !== positions) {
    t5 = pending || positions.some(position_0 => !answers[position_0]?.trim());
    $[14] = answers;
    $[15] = pending;
    $[16] = positions;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== pending || $[19] !== t5) {
    t6 = <button aria-busy={pending} className="min-h-11 rounded-md bg-primary px-4 text-primary-foreground" disabled={t5} type="submit">Confirm recovery phrase</button>;
    $[18] = pending;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== onBack || $[22] !== pending) {
    t7 = <button className="min-h-11 rounded-md border px-4" disabled={pending} onClick={onBack} type="button">Back to phrase</button>;
    $[21] = onBack;
    $[22] = pending;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = <div className="flex flex-wrap gap-3">{t6}{t7}</div>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t1 || $[28] !== t3 || $[29] !== t4 || $[30] !== t8) {
    t9 = <form className="space-y-4" onSubmit={t1}>{t2}{t3}{t4}{t8}</form>;
    $[27] = t1;
    $[28] = t3;
    $[29] = t4;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}